var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeroTriangles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 688,
    height: 791,
    viewBox: "1201 168 688 791",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipOuter"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 688,
    height: 791,
    fill: "white",
    transform: "translate(1201 168)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipOuter)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1825.84 867.557L1888.65 993.179C1855.76 1017.86 1820.71 1039.67 1783.65 1058.24L1722.1 935.139H1722.14L1716.78 924.454L1682.39 855.689L1648.01 786.924L1613.63 718.159L1579.25 649.394L1544.86 580.629L1510.48 511.864L1476.1 443.099L1441.72 374.334L1407.33 305.569L1476.06 168L1825.8 867.557H1825.84Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1665.56 959.507L1727.42 1083.28C1688.94 1098.42 1648.8 1110.13 1607.32 1118.17L1542.78 989.039L1338.57 580.59L1304.19 511.825L1372.95 374.295L1407.33 443.06L1441.72 511.825L1476.1 580.59L1510.48 649.355L1665.56 959.507Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1476.06 993.179L1543.17 1127.48C1521.13 1129.64 1498.69 1130.71 1476.06 1130.71C1452.2 1130.71 1428.71 1129.53 1405.52 1127.12L1328.48 973.07H1328.51L1304.19 924.414L1269.8 855.649L1235.42 786.884L1201 718.159L1269.76 580.629L1304.15 649.394L1313.18 667.453L1476.06 993.179Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroTriangles);
export default __webpack_public_path__ + "static/media/hero-triangles.0b020ded2ab3f1adda658860efd87f53.svg";
export { ForwardRef as ReactComponent };